module.exports = __webpack_public_path__ + "static/media/eg7.72b47d76.webp";